import { useState, useEffect } from 'react';
import { Form, Input, Row, Modal, Spin } from 'antd';
import classNames from 'classnames/bind';
import styles from './DownloadAPP.module.scss';
import { checkKeyDownNumberInput } from '~/utils';
import { IMAGES } from '~/assets/assetsPath';
import userAPI from '~/api/UserAPI';
import ReceiveRewardedSuccess from '~/components/ReceiveRewardedSuccess';
import { useParams } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useLocation } from 'react-router-dom';

const cx = classNames.bind(styles);

const data = [
    {
        title: 'Quickly book an appointment',
        content: 'Through the application, customers can proactively and flexibly schedule appointments as desired.',
    },
    {
        title: 'Full information about spa services',
        content: `The application provides complete information about the spa's services and products to help customers easily follow and learn.`,
    },
    {
        title: 'Modern AI skin scanning technology',
        content:
            'Based on AI artificial intelligence platform, the application analyzes and evaluates 48 skin parameters in detail. Establish a user-specific skin care routine.',
    },
    {
        title: 'Update spa exclusive offers',
        content:
            'Through the application, customers will receive incentives and participate in exclusive spa promotions as quickly as possible.',
    },
];

const DownloadAPP = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className={cx('wrapper')}>
            <Spin spinning={isLoading}>
                <div className={cx('container')}>
                    <div className={cx('form_container')}>
                        <Row justify="center" className={cx('title')} style={{ textAlign: 'center' }}>
                            Download the app to use the voucher
                        </Row>
                        <Row justify="center">
                            <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                <img src={IMAGES.NewLogo} alt="" width="100px" style={{ cursor: 'pointer' }} />
                            </a>
                        </Row>
                        <Row justify="center">
                            <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                <span className={cx('down_btn')}>Download</span>
                            </a>
                        </Row>
                        <Row
                            justify="center"
                            className={cx('title')}
                            style={{ textAlign: 'center', marginTop: '20px' }}
                        >
                            Outstanding features of the application
                        </Row>
                        <Row justify="center" style={{ marginBottom: '20px' }}>
                            <div className={cx('image_app')}>
                                <img src={IMAGES.ImageHomeAppHead} alt="" />
                            </div>
                        </Row>
                        {data?.map((item, index) => {
                            return (
                                <div className={cx('item')}>
                                    <Row className={cx('title')}>
                                        {index + 1}.&nbsp;{item.title}
                                    </Row>
                                    <Row className={cx('content')}>{item.content}</Row>
                                </div>
                            );
                        })}
                        <Row justify="center" className={cx('down_app')} style={{ textAlign: 'center' }}>
                            Get the app
                        </Row>
                        <Row justify="center">
                            <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                <img src={IMAGES.NewLogo} alt="" width="100px" style={{ cursor: 'pointer' }} />
                            </a>
                        </Row>
                        <Row justify="center" style={{ marginBottom: '50px' }}>
                            <a href="https://vbeauty.app.link/download" target="_blank" rel="noreferrer">
                                <span className={cx('down_btn')}>Download</span>
                            </a>
                        </Row>
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default DownloadAPP;
